import { IPlayerVideoData } from "./types";
import { formatDate } from "Utils/helper";
import { EMPTY_LABEL } from "App/constants";

export const getVideoColumns = (includeComments: boolean = true) => [
  {
    dataField: "video",
    title: "Asset",
    colWidth: "10%",
    formatter: (data: IPlayerVideoData) => {
      const { thumbnail_url, title } = data;
      const isPrivate = Boolean(data.is_private);

      return (
        <div className="d-flex align-items-center">
          <div
            className={`border-start border-4 ${
              isPrivate ? "border-danger" : "border-success"
            }`}
            style={{ width: "10px", height: "40px" }}
          ></div>
          <div className="thumbnail-box position-relative">
            <img src={thumbnail_url} alt={`video thumbnail ${title}`} />
          </div>
        </div>
      );
    },
  },
  {
    dataField: "title",
    title: "Title",
    colWidth: "10%",
    formatter: (data: IPlayerVideoData) => {
      return data.title ? data.title : EMPTY_LABEL;
    },
  },

  {
    dataField: "description",
    title: "Description",
    colWidth: "30%",
    formatter: (data: IPlayerVideoData) => {
      return data.description ? data.description : EMPTY_LABEL;
    },
  },
  {
    dataField: "kpoint_gcc_id",
    title: "KPOINT GCC ID",
    colWidth: "10%",
    formatter: (data: IPlayerVideoData) => {
      if (data?.kpoint_gcc_id) {
        const videoUrl = `${process.env.REACT_APP_KPOINT_API_HOST}web/videos/${data.kpoint_gcc_id}`;

        return (
          <a
            href={videoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary fw-bold text-decoration"
          >
            See Video
          </a>
        );
      }
      return <span className="text-dark">----</span>;
    },
  },
  ...(includeComments
    ? [
        {
          dataField: "comments",
          title: "Comments",
          colWidth: "30%",
          formatter: (data: IPlayerVideoData) => {
            const comments = data?.comments || [];

            if (comments.length === 0) {
              return EMPTY_LABEL;
            }

            return (
              <ul>
                {comments.map((comment) => (
                  <li key={comment.id}>
                    <b>{comment.commented_by}</b> : <span>{comment.text}</span>{" "}
                    -{" "}
                    <span className="text-muted">
                      {formatDate(comment.created_at)}
                    </span>
                  </li>
                ))}
              </ul>
            );
          },
        },
      ]
    : []),
  // NOTE: Privacy column removed for player assets - only strip color indicates privacy status
  // NOTE: Keeping delete action commented for easy rollback to hard delete
  // {
  //   dataField: "delete",
  //   title: "Action",
  //   colWidth: "10%",
  //   formatter: (data: IPlayerVideoData) => {
  //     return (
  //       <div className="d-flex">
  //         <ButtonIcon
  //           onClick={(event) => {
  //             event.stopPropagation();
  //             onDeleteRowClicked(data.id);
  //           }}
  //         >
  //           <FontAwesomeIcon icon={faTrash} />
  //         </ButtonIcon>
  //       </div>
  //     );
  //   },
  // },
];
